import React from 'react';
import ReactDOM from 'react-dom';
import BaseComponent from 'foundation/base-component';
import NewsFeedLiveLayout from './news-feed-live-layout';

class NewsFeedLiveComponent extends BaseComponent {
    constructor(...args) {
        super(...args);
        this.init();
    }

    init() {
        this.render();
    }

    onDestroy() {
        ReactDOM.unmountComponentAtNode(this.element);
    }

    render() {
        ReactDOM.render(
            <NewsFeedLiveLayout options={this.options} />,
            this.element
        );
    }
}

export default NewsFeedLiveComponent;
